<template>
  <div class="main_mfd">
    <!-- 头部 -->
    <div class="bread_nav clearfix">
      <div class="return clearfix" @click="$router.go(-1)">
        <img v-if="URL_MAQIN == 2" src="../assets/img/kjc返回.png" alt />
        <img v-if="URL_MAQIN == 1" src="../assets/img/返回.png" alt />
        返回上一页
      </div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">我的课堂</el-breadcrumb-item>
        <el-breadcrumb-item>薄弱知识点</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 介绍 -->
    <div class="mainBox">
      <div class="title">
        根据您的做题情况，建议你复习巩固以下知识点哦~
      </div>
      <div class="listBox">
        <div class="row" v-for="(item,index) in class_list" :key="index">
          <div>
            <img src="../assets/img/dott.png" alt="">
            {{item.title}}
          </div>
          <button @click="make1_question(item)">学习巩固</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Queschild } from "@/api/index";
export default {
  name: "",
  data() {
    return {
      URL_MAQIN: this.GLOBAL.PLATFORM,
      class_list: [],
    };
  },
  computed: {},
  components: {},
  watch: {},
  methods: {
    queschildM() {
      Queschild(this.$route.query.course_id, this.$route.query.id).then((res) => {
        let class_list = res;
        // this.is_type = class_list[0].type;
        console.log(this.is_type);
        for (let i = 0; i < class_list.length; i++) {
          class_list[i].show = false;
        }
        this.class_list = class_list;
      });
    },
    // 点击做题
    make1_question(item) {
      if (item.logic_content.data.redo_count > 0) {
        this.$router.push({
          path: "workZsdxx",
          query: {
            course_id: item.logic_content.data.params.course_id,
            chapter_id: item.logic_content.data.params.chapter_id,
            rule_tag: item.logic_content.temp_type,
            k_id: this.chapter_id,
            cid: item.logic_content.data.params.cid,
            course_chapter_id:item.id,
            isBr:1,
          }
        });
      } else {
        this.$router.push({
          path: "workZsdxx",
          query: {
            course_id: item.logic_content.data.params.course_id,
            chapter_id: item.logic_content.data.params.chapter_id,
            k_id: this.chapter_id,
            rule_tag: item.logic_content.temp_type,
            course_chapter_id:item.id,
            isBr:1
          }
        });
      }
    },



  },
  created() {
    this.queschildM()
  },
};
</script>

<style lang='scss' scoped>
.main_mfd {
  .bread_nav {
    padding: 12px 0 12px 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;
    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 45px;
      line-height: 28px;
      cursor: pointer;
      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }
    .el-breadcrumb {
      float: left;
      margin-top: 8px;
    }
    .jion {
      cursor: pointer;
      float: right;
      line-height: 24px;
      padding-right: 24px;
      img {
        float: left;
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
    }
  }
  .mainBox{
      .title{
          height: 80px;
          line-height: 80px;
          background: #fce025;
          font-size:20px;
          padding: 0 74px;
          border-top-left-radius: 14px;
          border-top-right-radius: 14px;
      }
      .listBox{
        background: white;
        padding-bottom: 100px;
        border-bottom-left-radius: 14px;
        border-bottom-right-radius: 14px;
        .row{
          height: 60px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 0 74px;
          border-bottom: 1px solid #eeeeee;
          img{
            margin-right: 6px;
          }
          button{
            width: 72px;
            height: 25px;
            background: #FADA1E;
            border-radius: 4px;
            border: 0;
            cursor: pointer;
          }
        }
      }
  }
}
</style>
